import React from "react"
import { Link } from "gatsby"
import DeliveryTeamImg from "../../../images/delivery-team.svg"

const Hero = () => {
  return (
    <section className="container mx-auto md:mt-20 px-6 pb-20">
      <div className="flex flex-col-reverse md:flex-row items-center">
        <div className="flex-1 md:w-1/2 md:pr-4">
          <h1 className="text-5xl lg:text-7xl font-light mb-8 leading-tight">
            <span className="text-secondary font-bold block">Delivery</span>{" "}
            Team
          </h1>
          <h3 className="text-3xl pb-8">
            We achieve effective project development, respecting cost and time
            constraints
          </h3>
          <h4 className="text-3xl pb-4">
            <span className="text-secondary">How does it work?</span>
          </h4>
          <p className="pb-12">
            We dedicate ourselves to train the ideal team for your project,
            according to the experience of each member of our staff. We have
            trained professionals in various areas
          </p>
          <Link
            to="/contact"
            className="mx-auto lg:mr-5 lg:mx-0 my-8 hover:text-white hover:bg-secondary hover:text-variant btn"
          >
            Get to know us
          </Link>
        </div>
        <div className="flex-1 my-8 md:my-0 w-full md:w-1/2">
          <img
            src={DeliveryTeamImg}
            alt="Why we are here?"
            className="mx-auto"
            width="500"
          />
        </div>
      </div>
    </section>
  )
}

export default Hero
